<template>
  <b-card no-body class="left-sidebar-controls">
    <b-card-body body-class="map-controls p-0">

      <!-- left panel with section selector -->
      <div class="sections-selector">
        <div
          v-for="(section, index) in sections.choices"
          :key="`section-${index}`"
          @click="toggleExpanded(section.value)"
          :title="section.description"
          class="section"
          :class="{'section__selected': sections.value === section.value}">
          <i class="fa fa-2x section__icon" :class="section.icon"></i>
        </div>
      </div>

      <!-- section 1: filter -->
      <div class="section-content" :class="{'section-content__enabled': isSectionEnabled('filters')}">
        <div @click="toggleExpanded(currentSection.value)" class="section-content__header">
          <i class="fa fa-angle-double-left"></i>
          &nbsp;Filters
        </div>

        <live-map-filters
          class="mt-2"
          @update="$emit('update', $event)" />
      </div>

      <!-- section 2: vessels -->
      <div class="section-content" v-if="isSectionEnabled('vessels')" :class="{'section-content__enabled': isSectionEnabled('vessels')}">
        <div @click="toggleExpanded(currentSection.value)" class="section-content__header">
          <i class="fa fa-angle-double-left"></i>
          &nbsp;Vessels
        </div>

        <live-map-vessels-list
          :selected-vessel="selectedVessel"
          :selected-vessel-details="selectedVesselDetails"
          @update:selected-vessel="$emit('update:selected-vessel', $event)" />
      </div>

      <!-- section 3 -->
      <div class="section-content" :class="{'section-content__enabled': isSectionEnabled('section3')}">
        <div @click="toggleExpanded(currentSection.value)" class="section-content__header">
          <i class="fa fa-angle-double-left"></i>&nbsp;
          TBD
        </div>
      </div>

    </b-card-body>
  </b-card>
</template>

<script>
import LiveMapFilters from '@/components/livemap/LiveMapFilters';
import LiveMapVesselsList from '@/components/livemap/LiveMapVesselsList';

export default {
  name: 'live-map-left-sidebar',

  components: {
    LiveMapVesselsList,
    LiveMapFilters,
  },

  props: {
    selectedVessel: {
      type: Number,
      default: null,
    },

    selectedVesselDetails: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      sections: {
        value: null,
        choices: [
          {
            value: 'filters',
            icon: 'fa-filter',
            description: 'Filters',
          },
          {
            value: 'vessels',
            icon: 'fa-globe',
            description: 'Vessels',
          },
          {
            value: 'section3',
            icon: 'fa-archive',
            description: 'TBD',
          },
        ],
      },
    };
  },

  methods: {
    toggleExpanded(sectionName) {
      if(this.sections.value === sectionName) {
        this.sections.value = null;
      } else {
        this.sections.value = sectionName;
      }
    },

    isSectionEnabled(sectionName) {
      return this.currentSection.value === sectionName;
    },
  },

  computed: {
    currentSection() {
      const defaultSection = {value: null};

      if(this.sections.value) {
        return this.sections.choices.find(item => item.value === this.sections.value) || defaultSection;
      } else {
        return defaultSection;
      }
    },
  }
}
</script>

<style>
/*
  styles are located in:
  src/assets/scss/components/live_map/controls.scss
*/
</style>